import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import RuleListComponent from "./component";

const RuleListContainer = (props) => {
  const { corporateId, departmentId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [resetRules, setResetRules] = useState([]);
  const [carryForwardRules, setCarryForwardRules] = useState([]);
  const [corporateName, setCorporateName] = useState("");
  const [departmentName, setDepartmentName] = useState("");
  const [ruleStatus, setRuleStatus] = useState("active");
  const [pgid, setPgid] = useState(null);
  const [accountType, setAccountType] = useState(null);
  
  const accountTypeFromQuery = queryParams.get('accountType') || "";
  const pgidFromQuery = queryParams.get('pgid') || "";
  
  const getPgIdFromAccountType = (accountTypeValue) => {
    if (accountTypeValue === "WALLET" || accountTypeValue === "wallet") {
      return "8";
    } else if (accountTypeValue === "WALLET_RFID" || accountTypeValue === "WALLET-RFID" || accountTypeValue === "wallet-RFID") {
      return "11";
    } else if (accountTypeValue === "BP" || accountTypeValue === "bp" || accountTypeValue === "BUSINESS_PARTNER") {
      return "12";
    }
    return "11";
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [ruleToDelete, setRuleToDelete] = useState(null);
  const [deleteRuleType, setDeleteRuleType] = useState(null);
  const [deleteDepartmentId, setDeleteDepartmentId] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  
  const corporateNameFromQuery = queryParams.get('corporateName') || "";
  
  useEffect(() => {
    const urlAccountType = queryParams.get('accountType');
    if (urlAccountType) {
      setAccountType(urlAccountType);
      const calculatedPgId = getPgIdFromAccountType(urlAccountType);
      setPgid(calculatedPgId);
    } else {
      setAccountType(null);
      setPgid("11");
    }
    
    if (location.state?.pgid) {
      setPgid(location.state.pgid);
    }
    if (location.state?.corporateName) {
      setCorporateName(location.state.corporateName);
    }
  }, [location.state, queryParams]);
  
  const handleBackClick = () => {
    const currentAccountType = accountTypeFromQuery || accountType;
    
    // Check if it's BP case (WALLET account type without pgid=11)
    // BP case mein accountType=WALLET hota hai but pgid alag hota hai
    const isBPCase = currentAccountType === "WALLET" && pgidFromQuery !== "11";
    
    // Check if it's Tag/Wallet RFID case
    const isTagRFIDCase = currentAccountType === "WALLET_RFID" || pgidFromQuery === "11";
    
    // Check if it's regular Wallet case
    const isRegularWalletCase = currentAccountType === "WALLET" && !pgidFromQuery;
    
    console.log("Back Navigation Debug:", {
      currentAccountType,
      pgidFromQuery,
      isBPCase,
      isTagRFIDCase,
      isRegularWalletCase,
      corporateId
    });
    
    if (isBPCase) {
      // Navigate to BP Corporate Dashboard
      navigate(`/home/customermanager/corporatedashboard/${corporateId}`, {
        state: {
          corporateName: corporateName,
          accountType: currentAccountType
        }
      });
    } else if (isTagRFIDCase || isRegularWalletCase) {
      // Navigate to Tag/Wallet Dashboard
      navigate(`/home/walletandtags/tagpay-dashboard/${corporateId}`, {
        state: {
          corporateName: corporateName,
          accountType: currentAccountType,
          pgid: pgid || pgidFromQuery || "11"
        }
      });
    } else {
      // Default fallback - Tag dashboard
      navigate(`/home/walletandtags/tagpay-dashboard/${corporateId}`, {
        state: {
          corporateName: corporateName,
          accountType: currentAccountType,
          pgid: pgid || "11"
        }
      });
    }
  };

  const handleAddRule = () => {
    const currentAccountType = accountTypeFromQuery;
    const currentPgId = pgidFromQuery || pgid || getPgIdFromAccountType(accountTypeFromQuery) || "11";
    
    navigate(`/home/customermanager/corporate/add-rule/${corporateId}?accountType=${currentAccountType}&pgid=${currentPgId}`);
  };

  const handleEditRule = (ruleId, departmentId, departmentName, ruleType) => {
    const currentAccountType = accountTypeFromQuery;
    const currentPgId = pgidFromQuery || pgid || getPgIdFromAccountType(accountTypeFromQuery) || "11";
    
    navigate(`/home/customermanager/corporate/edit-rule/${corporateId}/${departmentId}/${ruleId}?accountType=${currentAccountType}&pgId=${currentPgId}`, {
      state: {
        departmentName: departmentName,
        ruleType: ruleType,
        accountType: currentAccountType,
        ruleId: ruleId,
        pgid: currentPgId
      }
    });
  };

  const handleDeleteRule = (ruleId, ruleType, departmentId) => {
    if (departmentId === undefined || departmentId === null) {
      toastr.error("Error", "Invalid department ID");
      return;
    }
    
    setRuleToDelete(ruleId);
    setDeleteRuleType(ruleType);
    setDeleteDepartmentId(departmentId);
    setShowDeleteModal(true);
  };

  const handleStatusChange = (status) => {
    setRuleStatus(status);
  };

  const handleToggleRuleStatus = async (ruleId, ruleType, currentStatus) => {
    try {
      const newStatusText = currentStatus ? 'inactive' : 'active';
      
      const endpoint = `/partner/api/v1/corporate/${corporateId}/recharge-rules/${ruleId}/status`;
      const payload = { isActive: !currentStatus };
      
      await props.getDataFromAPI(
        endpoint,
        "PATCH",
        payload,
        (response) => {
          if (ruleType === 'reset') {
            setResetRules(prev => prev.map(rule => 
              rule.ruleId === ruleId 
                ? { ...rule, isActive: !currentStatus }
                : rule
            ));
          } else {
            setCarryForwardRules(prev => prev.map(rule => 
              rule.ruleId === ruleId 
                ? { ...rule, isActive: !currentStatus }
                : rule
            ));
          }
          
          toastr.success("Success", `Rule status updated to ${newStatusText}`);
        },
        (err) => {
          console.error("Error updating rule status:", err);
          toastr.error("Error", "Failed to update rule status");
        }
      );
      
    } catch (err) {
      console.error("Error updating rule status:", err);
      toastr.error("Error", "Failed to update rule status");
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setRuleToDelete(null);
    setDeleteRuleType(null);
    setDeleteDepartmentId(null);
    setIsDeleting(false);
  };

  const handleConfirmDelete = async () => {
    if (!ruleToDelete) {
      toastr.error("Error", "Rule ID is missing");
      return;
    }
    
    if (!deleteRuleType) {
      toastr.error("Error", "Rule type is missing");
      return;
    }
    
    if (!corporateId) {
      toastr.error("Error", "Corporate ID is missing");
      return;
    }
    
    if (deleteDepartmentId === undefined || deleteDepartmentId === null) {
      toastr.error("Error", "Department ID is missing");
      return;
    }

    try {
      setIsDeleting(true);
      
      const deleteUrl = `/partner/api/v1/recharge-rules/${corporateId}`;
      
      const payload = {
        departmentId: deleteDepartmentId,
        ruleId: ruleToDelete,
        ruleType: deleteRuleType
      };
      
      props.getDataFromAPI(
        deleteUrl,
        "DELETE",
        payload,
        (response) => {
          setShowDeleteModal(false);
          setRuleToDelete(null);
          setDeleteRuleType(null);
          setDeleteDepartmentId(null);
          setIsDeleting(false);
          
          toastr.success("Success", `${deleteRuleType === 'reset' ? 'Reset' : 'Carry Forward'} rule deleted successfully`);
          fetchRules();
        },
        (err) => {
          console.error("Error deleting rule:", err);
          toastr.error("Error", err?.message || "Failed to delete rule. Please try again.");
          setShowDeleteModal(false);
          setIsDeleting(false);
        }
      );
      
    } catch (err) {
      console.error("Error in delete operation:", err);
      toastr.error("Error", "Failed to delete rule");
      setShowDeleteModal(false);
      setIsDeleting(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) {
        const parts = dateString.split('-');
        if (parts.length === 3) {
          const year = parseInt(parts[0]);
          const month = parseInt(parts[1]) - 1;
          const day = parseInt(parts[2]);
          const newDate = new Date(year, month, day);
          if (!isNaN(newDate.getTime())) {
            return formatDateObject(newDate);
          }
        }
        return dateString;
      }
      return formatDateObject(date);
    } catch (err) {
      console.error("Error formatting date:", err, dateString);
      return dateString;
    }
  };

  const formatDateObject = (date) => {
    const day = date.getDate();
    const suffix = day % 10 === 1 && day !== 11 ? 'st' : 
                   day % 10 === 2 && day !== 12 ? 'nd' : 
                   day % 10 === 3 && day !== 13 ? 'rd' : 'th';
    
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    
    return `${day}${suffix} ${month} ${year}`;
  };

  const formatFrequency = (freq) => {
    if (!freq) return 'Monthly';
    const freqMap = {
      'MONTHLY': 'Monthly',
      'WEEKLY': 'Weekly',
      'DAILY': 'Daily',
      'YEARLY': 'Yearly',
      'Monthly': 'Monthly',
      'Weekly': 'Weekly',
      'Daily': 'Daily',
      'Yearly': 'Yearly'
    };
    return freqMap[freq] || freq.charAt(0).toUpperCase() + freq.slice(1).toLowerCase();
  };

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null) return '₹ 0.00';
    return `₹ ${parseFloat(amount).toFixed(2)}`;
  };

  const fetchRules = useCallback(() => {
    if (!corporateId) {
      setError("Corporate ID is required");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    let endpoint = `/partner/api/v1/corporate/${corporateId}/recharge-rules`;
    
    const pgIdValue = pgidFromQuery || getPgIdFromAccountType(accountTypeFromQuery);
    
    const queryParamsList = [];
    
    if (pgIdValue) {
      queryParamsList.push(`pgId=${pgIdValue}`);
    }
    
    if (departmentId !== undefined && departmentId !== null && departmentId !== 0) {
      queryParamsList.push(`departmentId=${departmentId}`);
    }
    
    if (queryParamsList.length > 0) {
      endpoint += `?${queryParamsList.join('&')}`;
    }

    props.getDataFromAPI(
      endpoint,
      "GET",
      undefined,
      (response) => {
        try {
          let resetData = [];
          let carryForwardData = [];
          
          if (response) {
            const { resetRules = [], carryForwardRules = [] } = response;
            
            if (Array.isArray(resetRules)) {
              resetData = resetRules.map(rule => ({
                ruleId: rule.ruleId,
                departmentId: rule.departmentId,
                department: rule.department || "General",
                amount: formatCurrency(rule.amount),
                frequency: formatFrequency(rule.frequency),
                resetOn: formatDate(rule.resetOn),
                isActive: rule.isActive !== undefined ? rule.isActive : true
              }));
            }
            
            if (Array.isArray(carryForwardRules)) {
              carryForwardData = carryForwardRules.map(rule => ({
                ruleId: rule.ruleId,
                departmentId: rule.departmentId,
                department: rule.department || "General",
                amount: formatCurrency(rule.amount),
                minRequest: formatCurrency(rule.minRequest),
                frequency: formatFrequency(rule.frequency),
                carryForwardOn: formatDate(rule.carryForwardOn),
                isActive: rule.isActive !== undefined ? rule.isActive : true
              }));
            }
          }
          
          setResetRules(resetData);
          setCarryForwardRules(carryForwardData);
          
          if (corporateNameFromQuery) {
            setCorporateName(corporateNameFromQuery);
          } else {
            fetchCorporateDetails();
          }
          
        } catch (err) {
          console.error("Error processing rule data:", err);
          setError("Failed to process rule data");
        }
        
        setLoading(false);
      },
      (err) => {
        console.error("Error fetching rules:", err);
        setError("Failed to load rules. Please try again.");
        setLoading(false);
        toastr.error("Failed", "Unable to fetch rules");
      }
    );
  }, [corporateId, departmentId, corporateNameFromQuery, accountTypeFromQuery, pgidFromQuery, props.getDataFromAPI]);

  const fetchCorporateDetails = useCallback(() => {
    if (!corporateNameFromQuery && corporateId) {
      props.getDataFromAPI(
        `/partner/api/v2/corporate/${corporateId}`,
        "GET",
        undefined,
        (response) => {
          if (response && (response.corporateName || response.name)) {
            setCorporateName(response.corporateName || response.name);
          } else {
            setCorporateName(`Corporate ${corporateId}`);
          }
        },
        (err) => {
          console.error("Error fetching corporate details:", err);
          setCorporateName(`Corporate ${corporateId}`);
        }
      );
    } else if (corporateNameFromQuery) {
      setCorporateName(corporateNameFromQuery);
    }
  }, [corporateId, corporateNameFromQuery, props.getDataFromAPI]);

  useEffect(() => {
    if (corporateId) {
      fetchRules();
      if (!corporateNameFromQuery) {
        fetchCorporateDetails();
      }
    }
  }, [corporateId, fetchRules, fetchCorporateDetails, corporateNameFromQuery]);

  const refreshRules = () => {
    fetchRules();
  };

  return (
    <RuleListComponent
      loading={loading}
      error={error}
      resetRules={resetRules}
      carryForwardRules={carryForwardRules}
      corporateName={corporateName}
      departmentName={departmentName}
      ruleStatus={ruleStatus}
      showDeleteModal={showDeleteModal}
      ruleToDelete={ruleToDelete}
      deleteRuleType={deleteRuleType}
      deleteDepartmentId={deleteDepartmentId}
      isDeleting={isDeleting}
      onBackClick={handleBackClick}
      onAddRuleClick={handleAddRule}
      onEditRuleClick={handleEditRule}
      onDeleteRuleClick={handleDeleteRule}
      onStatusChange={handleStatusChange}
      onToggleRuleStatus={handleToggleRuleStatus}
      onCancelDelete={handleCancelDelete}
      onConfirmDelete={handleConfirmDelete}
      onRefreshRules={refreshRules}
    />
  );
};

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {
  getDataFromAPI,
})(RuleListContainer);